import "core-js/modules/es.array.push.js";
export default {
  methods: {
    back() {
      this.$router.push('/profile-settings').catch(err => {
        if (err.name !== "NavigationDuplicated") throw err;
      });
    }
  }
};